var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M12,0H2A2,2,0,0,0,0,2V18l7-3,7,3V2A2,2,0,0,0,12,0Zm0,15L7,12.82,2,15V2H12Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }